import { render, staticRenderFns } from "./waterFallMobile.vue?vue&type=template&id=b5635040&"
import script from "./waterFallMobile.vue?vue&type=script&lang=js&"
export * from "./waterFallMobile.vue?vue&type=script&lang=js&"
import style0 from "./waterFallMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports